import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function FinalCTASection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-14 md:py-24 px-4 bg-brand-dark text-white text-center" data-id="element-92">
      <div className="max-w-4xl mx-auto" data-id="element-93">
        <div className="inline-block bg-white/10 text-white font-bold px-6 py-2 rounded-full mb-5 md:mb-8 border border-white/20" data-id="element-94">
          🧬 BIOLOGÍA EN ACCIÓN
        </div>

        <h2 className="text-2xl md:text-5xl font-black mb-5 md:mb-8 leading-tight" data-id="element-95">
          El próximo domingo podés seguir buscando material en Google.
          <br data-id="element-96" />
          <span className="text-brand-orange" data-id="element-97">
            O podés tener todo resuelto desde hoy.
          </span>
        </h2>

        <div className="bg-[#252542] p-5 md:p-8 rounded-3xl border border-gray-700 mb-8 md:mb-12" data-id="element-98">
          <p className="text-xl font-bold text-gray-300 mb-4" data-id="element-99">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex justify-center gap-4 mb-6" data-id="element-100">
            <div className="text-4xl md:text-5xl font-black text-brand-orange" data-id="element-101">
              {formatTime(hours)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-102">hs</span>
            </div>
            <div className="text-4xl md:text-5xl font-black text-gray-500" data-id="element-103">
              :
            </div>
            <div className="text-4xl md:text-5xl font-black text-brand-orange" data-id="element-104">
              {formatTime(minutes)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-105">min</span>
            </div>
            <div className="text-4xl md:text-5xl font-black text-gray-500" data-id="element-106">
              :
            </div>
            <div className="text-4xl md:text-5xl font-black text-brand-orange" data-id="element-107">
              {formatTime(seconds)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-108">seg</span>
            </div>
          </div>
          <p className="text-red-400 font-bold" data-id="element-109">
            Después sube $10.000 ARS y no vuelve.
          </p>
        </div>

        <div className="space-y-4 md:space-y-6 max-w-2xl mx-auto mb-8 md:mb-12 flex flex-col items-center" data-id="element-110">
          {/* Highlighted Pack */}
          <div className="bg-white text-brand-dark p-6 rounded-2xl shadow-2xl border-4 border-brand-orange relative w-full" data-id="element-111">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-brand-orange text-white font-black px-4 py-1 rounded-full text-xs" data-id="element-112">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-4" data-id="element-113">
              <div className="text-left" data-id="element-114">
                <h3 className="text-2xl font-black flex items-center gap-2" data-id="element-115">
                  📗 PACK AVANZADO
                </h3>
              </div>
              <div className="text-3xl font-black text-brand-orange" data-id="element-116">
                $19.990 pesos
              </div>
            </div>
            <CTAButton text="→ QUIERO MI MEGAPACK AVANZADO" href="https://checkout.guiadigital360.online/cart/44131411918917:1" isLink={true} data-id="element-117" />
          </div>

          {/* VIP Pack */}
          <div className="bg-[#252542] p-6 rounded-2xl border border-gray-700 w-full" data-id="element-118">
            <h3 className="text-xl font-bold mb-2" data-id="element-119">
              🚀 COMBO GESTIÓN TOTAL VIP
            </h3>
            <p className="text-xs text-gray-400 mb-2" data-id="element-120">
              Contiene lo del Pack Avanzado + Gestión Total VIP
            </p>
            <div className="text-2xl font-black text-white mb-4" data-id="element-121">
              $24.990 pesos
            </div>
            <CTAButton text="→ QUIERO COMBO VIP" href="https://checkout.guiadigital360.online/cart/44777826648133:1" isLink={true} className="text-sm py-3 bg-brand-blue hover:bg-blue-700 shadow-[0_8px_25px_-5px_rgba(0,87,217,0.5)] hover:shadow-[0_12px_30px_-5px_rgba(0,87,217,0.7)]" data-id="element-122" />
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-400 font-medium" data-id="element-123">
          <span className="flex items-center gap-2" data-id="element-124">
            <LockIcon className="w-5 h-5" data-id="element-125" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-126">
            <ZapIcon className="w-5 h-5 text-yellow-500" data-id="element-127" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-128">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-129" /> Garantía 7
            días sin preguntas
          </span>
          <span className="flex items-center gap-2" data-id="element-130">
            <CreditCardIcon className="w-5 h-5" data-id="element-131" /> Mercado Pago | Tarjeta |
            Transferencia
          </span>
        </div>
      </div>
    </section>;
}